import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const addEmployee = async (addEmployeeData: any) => {
	const requestData = {
		AddEmployeeDetailsToken: addEmployeeData,
	};
	const url = `${API_URL}AddEmployeeDetails`;
	return makeApiCall(url, requestData);
};

export const getEmployeeNameAndIDAPI = async (getEmployeeNameAndIDData: any) => {
	const requestData = {
		getEmployeeToken: getEmployeeNameAndIDData,
	};
	const url = `${API_URL}GetAllEmployeeNameAndID`;
	if (process.env.NODE_ENV === 'development') console.log(getEmployeeNameAndIDData, 'getEmployeeNameAndIDData');
	return makeApiCall(url, requestData);
};
